// BUGBUG Currently, getXmlAsync is the best way to get text because it translates
// SharePoint URLs to REST URLs if needed.
// As of 2025-04-16 it does not have any actual XML-specific behavior, but
// we should rename it or add a new method at some point
export const queryTextFromUrl = (url, api) => api.getXmlAsync(url);
